// import { render } from 'react-dom'
// import React from 'react'

class Widget {
  constructor(props) {
    this.enableZoomWidget = props.enableZoomWidget
    this.zoomWidgetContainer = props.zoomWidgetContainer
    this.transform = props.transform
    this.zoomIn = props.zoomIn
    this.zoomOut = props.zoomOut
    this.zoomBy = props.zoomBy
    this.resetZoom = props.resetZoom
    this.zoomExtent = props.zoom.scaleExtent()
    this.draw()
  }

  udpate = ({ transform, zoom }) => {
    this.transform = transform
    this.zoomExtent = zoom.scaleExtent()
    this.draw()
  }

  draw = () => {
    // const {
    //   transform: t,
    //   zoomExtent,
    //   zoomIn,
    //   zoomOut,
    //   zoomBy,
    //   resetZoom,
    //   enableZoomWidget,
    // } = this
    // if (enableZoomWidget) {
    //   render(
    //     <ZoomWidget
    //       zoomLevel={t.k}
    //       zoomExtent={zoomExtent}
    //       zoomIn={zoomIn}
    //       zoomOut={zoomOut}
    //       zoomBy={zoomBy}
    //       resetZoom={resetZoom}
    //     />,
    //     this.zoomWidgetContainer
    //   )
    // }
  }
}

export default Widget
